import React from 'react';

const LoginPhone = () => <div />;

export default LoginPhone;
